export enum HomeRequestTypes {
  GetHomeRequest = 'Home.GetHome.Request',
  GetHomeSuccess = 'Home.GetHome.Success',
  GetHomeFailure = 'Home.GetHome.Failure',
  SetHomeRequest = 'Home.SetHome.Request',
  SetHomeSuccess = 'Home.SetHome.Success',
  SetHomeFailure = 'Home.SetHome.Failure',
  CreateHomeSectionRequest = 'Home.CreateHomeSection.Request',
  CreateHomeSectionSuccess = 'Home.CreateHomeSection.Success',
  CreateHomeSectionFailure = 'Home.CreateHomeSection.Failure',
  SetHomeSectionRequest = 'Home.SetHomeSection.Request',
  SetHomeSectionSuccess = 'Home.SetHomeSection.Success',
  SetHomeSectionFailure = 'Home.SetHomeSection.Failure',
  SetSectionOrderRequest = 'Home.SetSectionOrder.Request',
  SetSectionOrderSuccess = 'Home.SetSectionOrder.Success',
  SetSectionOrderFailure = 'Home.SetSectionOrder.Failure',
  DeleteHomeSectionRequest = 'Home.DeleteHomeSection.Request',
  DeleteHomeSectionSuccess = 'Home.DeleteHomeSection.Success',
  DeleteHomeSectionFailure = 'Home.DeleteHomeSection.Failure',
  SetHomeCardRequest = 'Home.SetHomeCard.Request',
  SetHomeCardSuccess = 'Home.SetHomeCard.Success',
  SetHomeCardFailure = 'Home.SetHomeCard.Failure',
  DeleteHomeCardRequest = 'Home.DeleteHomeCard.Request',
  DeleteHomeCardSuccess = 'Home.DeleteHomeCard.Success',
  DeleteHomeCardFailure = 'Home.DeleteHomeCard.Failure',
  DuplicateHomeCardRequest = 'Home.DuplicateHomeCard.Request',
  DuplicateHomeCardSuccess = 'Home.DuplicateHomeCard.Success',
  DuplicateHomeCardFailure = 'Home.DuplicateHomeCard.Failure',
}
